export const getModelMotivoConsulta = () => ({
    iIdMotivoConsulta: 0,
});

export const getFormMotivoConsulta = () => ({
    txtNombre: {
        label: "Motivo de consulta:",
        required: true,
        value: "",
        error: false,
        message: "El motivo de consulta es requerido",
    },
    txtNombreEng: {
        label: "Motivo de consulta Inglés:",
        required: true,
        value: "",
        error: false,
        message: "El motivo de consulta en inglés es requerido",
    },
});

export const getMotivoConsultaColumns = () => [
    { title: "ID", field: "iIdMotivoConsulta" },
    { title: "Motivo de consulta", field: "sNombre" },
    { title: "Motivo de consulta en Inglés", field: "sNombreIngles" },
    { title: "Creado", field: "sFechaCreacion" },
];
